<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen">
		<div class="head head-with-brand big">
			<div class="container">
				<div class="btn icon icon-close invert" @click="cancelControl"></div>
				<small>CHASSIS</small>
				<h1>{{control.car.chassis_number}}</h1>
				<h2>{{control.car.brand.title}} {{control.car.model}}</h2>
				<div class="brand" v-if="control.car.brand.logo" :style="{backgroundImage:`url(${API_URL+control.car.brand.logo.urlThumb})`}"></div>
			</div>
		</div>
		
		<div class="content">
			<div class="container">
				
				<div class="card box-shadow mt-4">
					<div class="card-body">
						<h5 class="card-title">Cargos</h5>

						<table class="table">
							<tr v-for="charge in control.charges" :key="charge.key" @click="updateCharge(charge)">
								<td>{{charge.description}}</td>
								<td class="text-right">U$S {{charge.price}}</td>
							</tr>
						</table>
						
						<div class="btn btn-sm btn-success pull-right mt-4"  @click="newItem()">Agregar cargo</div>
					</div>	
				</div>
				
			</div>
		</div>

		<div class="footer">
			<div class="container">
				<div class="btn btn-block btn-primary" @click="finishControl()">
					Finalizar
				</div>
			</div>
		</div>

	</div>

	<ChargeForm ref="chargeForm"></ChargeForm>

	<b-modal id="modalSuccess" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
		<div class="fullscreen">

			<div class="head head-success xl">
				<div class="container text-center">
					<i class="icon mt-4 icon-xl invert icon-check"></i>
					<h1 class="mt-4">Cargos creados correctamente</h1>
				</div>
			</div>
			
			<div class="content bg-grey">
				<div class="container">
					<div class="p-4 mt-4">
					</div>					
				</div>
			</div>
			<div class="footer">
				<div class="container">
					<div class="btn btn-block btn-primary" @click="close()">
						Cerrar
					</div>
				</div>
			</div>
		</div>
	</b-modal>

</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'
import ChargeForm from '@/components/ChargeForm'

export default {
	name: 'CarPreDelivery',
	mixins:[mixins],
	components: {
		Loader,
		ChargeForm,
	},
	data(){
		return{
			loading: false,
			saving: false,
			API_URL: process.env.VUE_APP_API_URL,
			controlCreated: null,
		}
	},
	computed: {
		...mapState(['control'])
	},
	methods:{
		...mapMutations(['saveControl','deleteControl']),
		newItem(){
			this.$refs.chargeForm.open()
		},
		updateCharge(charge){
			this.$refs.chargeForm.update(charge)
		},
		cancelControl(){
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		},
		async finishControl(){
			if(!this.saving && this.control.charges.length>0 ) {
				this.saving = true
				
				//arreglo charges.
				var charges = []
				this.control.charges.forEach( charge =>{
					charges.push({
						description: charge.description,
						price: charge.price,
						files: charge.files.map(a => a.id)
					})
				})
				let dataInput = {
					car_id 			: this.control.car.id,
					charges			: charges,
				}
				
				return this.$apollo.mutate({
					mutation: gql`mutation ( $data:ControlChargesInput! ){
						controlCharges( data: $data) {
							id
							car{
								id
							}
							user{
								name
							}
							type
							typeText
							charges{
								description
								price
							}
						}
					}`,
					variables: {
						data: dataInput
					}
				})
				.then((data) => {
					this.controlCreated = data.data.controlCharges
					this.saving = false
					this.control.step = 'ControlSuccess'
					this.$bvModal.show('modalSuccess')
				})
				.catch( (error) => {
					this.errors = this.parseGQLErrors(error)
					this.$toast.error('Error!')
					this.saving = false
				})
			}
		},
		close(){
			this.show = false
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		}
	}
	
}
</script>

<style scoped lang="scss">

</style>
